import request from '@/utils/request'

export function wxLogin(data) {
  return request.post('/user/wx-login', data)
}

export function login(data) {
  return request.post('/user/login', data)
}

export function getInfo() {
  return request.post('/user/get-login-info')
}

export function logout() {
  return request.post('/user/logout')
}



// WEBPACK FOOTER //
// ./src/api/user.js